import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { useToast } from '../hooks/use-toast';
import { portfolioData } from '../mock';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Contact = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/contact`, formData);
      
      if (response.data.success) {
        toast({
          title: "Nachricht gesendet!",
          description: response.data.message,
        });
        setFormData({ name: '', email: '', phone: '', message: '' });
      }
    } catch (error) {
      console.error('Contact form error:', error);
      const errorMessage = error.response?.data?.detail || "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.";
      toast({
        title: "Fehler",
        description: errorMessage,
        variant: "destructive",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-20 px-6 lg:px-8 bg-[#F8FAFC]">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16">
          <div>
            <h2 className="text-5xl sm:text-6xl font-bold text-black mb-8">
              Kontakt
            </h2>
            <p className="text-xl text-gray-600 mb-12">
              Lassen Sie uns über Ihr Projekt sprechen
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <Mail className="text-[#1E40AF] mt-1" size={24} />
                <div>
                  <div className="text-sm text-gray-600 mb-1">E-Mail</div>
                  <a href={`mailto:${portfolioData.email}`} className="text-lg text-black hover:text-[#1E40AF] transition-colors font-medium">
                    {portfolioData.email}
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Phone className="text-[#1E40AF] mt-1" size={24} />
                <div>
                  <div className="text-sm text-gray-600 mb-1">Telefon</div>
                  <a href={`tel:${portfolioData.phone}`} className="text-lg text-black hover:text-[#1E40AF] transition-colors font-medium">
                    {portfolioData.phone}
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <MapPin className="text-[#1E40AF] mt-1" size={24} />
                <div>
                  <div className="text-sm text-gray-600 mb-1">Standort</div>
                  <div className="text-lg text-black font-medium">{portfolioData.location}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-sm border border-[#E2E8F0]">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-semibold text-black mb-2">
                  Name
                </label>
                <Input
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Ihr Name"
                  className="border-[#E5DFD5] focus:border-[#1E40AF] focus:ring-[#1E40AF] py-6 text-base"
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-black mb-2">
                  E-Mail
                </label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="ihre@email.de"
                  className="border-[#E5DFD5] focus:border-[#1E40AF] focus:ring-[#1E40AF] py-6 text-base"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-semibold text-black mb-2">
                  Telefon
                </label>
                <Input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="+49 (0) 6107 123456"
                  className="border-[#E5DFD5] focus:border-[#1E40AF] focus:ring-[#1E40AF] py-6 text-base"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-semibold text-black mb-2">
                  Nachricht
                </label>
                <Textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Erzählen Sie mir von Ihrem Projekt..."
                  rows={6}
                  className="border-[#E5DFD5] focus:border-[#1E40AF] focus:ring-[#1E40AF] resize-none text-base"
                />
              </div>

              <Button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#1E40AF] hover:bg-[#1E3A8A] text-white transition-all py-7 text-base font-semibold"
                size="lg"
              >
                {isSubmitting ? 'Wird gesendet...' : 'Nachricht senden'}
                <Send className="ml-2" size={20} />
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;